import rules from './rules'

export default {
  install(Vue) {
    if (this.installed) return
    Vue.prototype.$validationRules = rules
    this.installed = true
  },
}
